/**
 * Adds a query parameter to a URL which may already have a query string.
 * Document links are signed (SAS) URLs, a second "?" would corrupt their signature.
 */
export function withQueryParam(
  url: string,
  name: string,
  value: string | number | null | undefined
): string {
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}${encodeURIComponent(name)}=${encodeURIComponent(String(value ?? ''))}`;
}
